const Checkmark = ({
  width = 14,
  height = 11,
  fill = '#fff',
  stroke = '#fff',
}) => (
  <svg width={width} height={height} viewBox="0 0 14 11">
    <path
      d="M5.595 9.966a.877.877 0 01-.62-.255L1.256 5.958a.892.892 0 010-1.252.872.872 0 011.24 0l3.061 3.09 5.921-6.511a.873.873 0 011.24-.051c.354.332.38.893.05 1.25L6.253 9.686a.922.922 0 01-.632.294c-.013-.013-.013-.013-.026-.013z"
      fill={fill}
      fillRule="nonzero"
      stroke={stroke}
      strokeWidth={0.5}
    />
  </svg>
);

export default Checkmark;
